var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F7EAD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5742 23.3749L21.1992 9.19995C20.9742 8.86245 20.5617 8.63745 20.1492 8.63745C19.7367 8.63745 19.3242 8.86245 19.0992 9.19995L10.3242 22.6249C10.2867 22.6624 10.2867 22.6999 10.2867 22.7374C9.61172 23.5249 9.19922 24.3874 9.19922 25.3624C9.19922 28.7374 14.1117 31.3624 20.3742 31.3624C24.3492 31.3624 27.9117 30.3125 29.9367 28.5124C30.2742 28.2125 30.3117 27.6874 30.0117 27.3124C29.7117 26.9749 29.1867 26.9374 28.8117 27.2374C27.1242 28.7374 23.8992 29.6374 20.3742 29.6374C14.7867 29.6374 10.8867 27.3499 10.8867 25.3249C10.8867 23.4124 14.3367 21.275 19.3617 21.0499V24.2C19.3617 25.025 20.0367 25.6624 20.8617 25.6624H29.3367C29.8992 25.6624 30.3867 25.3624 30.6492 24.875C30.9117 24.4249 30.8742 23.8249 30.5742 23.3749ZM19.3242 11.975L19.3617 19.3624C17.2617 19.4749 15.3492 19.8499 13.7367 20.4874L19.3242 11.975ZM21.0492 23.9749V21.0125C21.7992 21.05 22.5117 21.0875 23.1867 21.2C23.6367 21.275 24.0867 20.9374 24.1617 20.4874C24.2367 20.0374 23.8992 19.5875 23.4492 19.5125C22.6617 19.4 21.8742 19.325 21.0492 19.2874L21.0117 11.9375L28.9617 23.9374H21.0492V23.9749Z",
    fill: "#DF8A0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTocIcon);
export default __webpack_public_path__ + "static/media/TOC-icon.87a467f5dccd5bd3c512ab17a24096f1.svg";
export { ForwardRef as ReactComponent };